import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer"

export const rawRichTextToString = (raw?: string | null) => {
  if (!raw) return ""

  try {
    const json = JSON.parse(raw)
    return documentToPlainTextString(json)
  } catch (error) {
    return ""
  }
}
